var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChinaHowItWorks2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2296 35.4824C40.4628 35.4824 34.9703 40.9749 34.9703 47.7417C34.9703 54.5084 40.4628 60.0009 47.2296 60.0009C53.9963 60.0009 59.4888 54.5084 59.4888 47.7417C59.4888 40.9749 53.9963 35.4824 47.2296 35.4824ZM42.2094 50.4037L44.7909 52.9852C45.1827 53.377 45.721 53.582 46.2739 53.5491C46.8231 53.5161 47.3358 53.2525 47.6763 52.8204L52.6195 46.5882C53.2823 45.7497 53.1395 44.5304 52.3046 43.8676C51.4698 43.2049 50.2468 43.344 49.584 44.1825L45.9956 48.712L44.952 47.6684C44.1941 46.9105 42.9711 46.9105 42.2131 47.6684C41.4588 48.4191 41.4588 49.6494 42.2094 50.4037Z",
    fill: "#FEBC11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1732 34.1926H4V50.3222C4 52.2043 4.74698 54.0095 6.07616 55.3424C7.40901 56.6715 9.21421 57.4185 11.0963 57.4185H35.981C33.7437 54.8187 32.3889 51.4354 32.3889 47.7408C32.3889 41.71 35.9993 36.5141 41.1732 34.1926ZM21.4222 45.8074H13.6778C12.6086 45.8074 11.7408 46.6752 11.7408 47.7444C11.7408 48.8136 12.6086 49.6814 13.6778 49.6814H21.4222C22.4914 49.6814 23.3592 48.8136 23.3592 47.7444C23.3592 46.6752 22.4914 45.8074 21.4222 45.8074ZM4 30.3222H54.3296V27.0963C54.3296 25.2142 53.5826 23.409 52.2534 22.0762C50.9205 20.747 49.1153 20 47.2332 20C38.2951 20 20.0381 20 11.1 20C9.21787 20 7.41267 20.747 6.07982 22.0762C4.75064 23.409 4.00366 25.2142 4.00366 27.0963C4 27.0963 4 30.3222 4 30.3222Z",
    fill: "#21438E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChinaHowItWorks2);
export default __webpack_public_path__ + "static/media/china-how-it-works-2.f583c4cd419769e52510d07b688507a2.svg";
export { ForwardRef as ReactComponent };